import React, { Component } from 'react';
import Select from 'react-select';
import IconKMSImageIcon from '../../../assets/icons/IconKMSImageIcon';
import IconKMSUpload from '../../../assets/icons/IconKMSUpload';
import RadioTab from '../../../components/Radio/RadioTab';
import CreatableSelect from 'react-select/creatable';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import { connect } from 'react-redux';
import ActionType from '../../../redux/reducer/globalActionType';
import API_KMS from '../../../api/apiKMS';
import { errorHandler, getContent } from '../../../util/responseUtil';
import { last } from 'lodash';
import MENU_KMS from '../../../constants/menuKMSConstant';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';

class KMSListDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataKMS: {
                id: "",
                category: "",
                title: "",
                description: "",
                type: "",
                urlLink: "",
                tags: [],
                imageFile: null,
                status: "",
                rating: 0,
                totalRate: 0,
                ratingRemark: []
            },
            tagOptionsList: [],
            errorMessage: "",
            showErrorAlertResponse: false,
            showPopupImage: false,
            showConfirmAlert: false,
            showSuccessAlert: false,
            disableField: true,
        }
    }

    componentDidMount() {
        if (!this.props.history.location.state) {
            this.props.history.push(ROUTER_CONSTANT.SETTINGS_KMS_CATEGORY);
        }

        let kmsIdFromHistoryState = this.props.history.location.state.kmsId;
        this.getDetailKMS(kmsIdFromHistoryState);
        this.getTagOptionsList();
    }

    getDetailKMS = (kmsId) => {
        API_KMS.getDetailKMS(kmsId, this.props.token)
            .then(res => {
                let ratingRemark = getContent(res).rating_remark;
                let ratingRate = getContent(res).rating_rate;
                let rating = ratingRemark.map((remark, idx) => ({
                    remark,
                    rate: ratingRate[idx]
                }));

                this.setState({
                    dataKMS: {
                        id: getContent(res).id,
                        category: getContent(res).category,
                        title: getContent(res).title,
                        description: getContent(res).description,
                        type: this.getTypeFunction(getContent(res).type),
                        urlLink: getContent(res).url_link,
                        imageFile: getContent(res).picture_link,
                        tags: this.getTagsFunction(getContent(res).tags),
                        status: String(getContent(res).status),
                        rating: getContent(res).rating,
                        totalRate: getContent(res).total_rate,
                        ratingRemark: rating
                    }
                });
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                if (err.response.data.nexsoft.payload.status.message === "Data id tidak diketahui") {
                    this.handleBackToKMSList();
                    setTimeout(() => alert('Data tidak ditemukan!'), 1000);
                }
            }))
    }

    getTagOptionsList = () => {
        API_KMS.getTagOptionsList(this.props.token)
            .then(res => {
                this.setState({
                    tagOptionsList: getContent(res).map(
                        obj => (Object.assign({ label: obj.description, value: obj.remark }))
                    )
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.handleCancelKMSListAdd();
            }))
    }

    getTypeFunction = value => {
        switch (value) {
            case "C":
                return MENU_KMS.typeOptions[0];
            case "I":
                return MENU_KMS.typeOptions[1];
            case "B":
                return MENU_KMS.typeOptions[2];
            default:
                return { label: "", value: "" };
        }
    }

    getTagsFunction = value => {
        let processTags = [];
        if (value !== null) {
            processTags = value.map(
                obj => (Object.assign({ label: obj.description, value: obj.remark }))
            )
        }
        return processTags;
    }

    handleCategoryKMSMenu = () => {
        const getIdFromHistoryState = this.props.history.location.state.categoryKMSDetail.id;
        this.props.history.push(`/settings/kms/category/detail/${getIdFromHistoryState}`);
    }

    handleBackToKMSList = () => {
        const getCategoryKMSDetailFromHistoryState = this.props.history.location.state.categoryKMSDetail;
        this.props.history.goBack();
        this.props.history.push({ state: { categoryKMSDetail: getCategoryKMSDetailFromHistoryState } });
    }

    getFilenameFromUrl = value => {
        if (value) {
            return last(value.split("/"));
        }
    }

    render() {
        return (
            <>
                <div className="space-y-3">
                    <BreadCrumbs
                        parentMenu="Pengaturan"
                        serviceMenu="KMS"
                        menuItem="Detail Daftar KMS"
                        title="Knowledge Management Sistem"
                    />

                    {/* WHITECONTAINER */}
                    <div className="white-container pb-10">
                        <div className="w-full bg-white border border-gray-300 rounded-lg p-8">
                            {/* MENU HEADBAR */}
                            <div className="flex items-center space-x-5 text-2xl text-gray-700 pb-10">
                                <button className={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_KMS_CATEGORY) ? "active-menu-kms font-medium" : "font-medium"} onClick={this.handleCategoryKMSMenu}>
                                    Kategori KMS
                                </button>
                                <button className={`
                                    ${window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_KMS_LIST) ? "active-menu-kms font-medium" : "font-medium"}
                                    "cursor-pointer"
                                `}
                                >
                                    Daftar KMS
                                </button>
                            </div>
                            {/* CONTENT */}
                            <div className="relative">
                                {/* Form */}
                                <div className="space-x-20 flex">
                                    {/* Right */}
                                    <div className="space-y-4 flex-initial w-3/12">
                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">ID KMS</p>
                                            </div>
                                            <input
                                                type="text"
                                                name="id"
                                                className="form-control w-full"
                                                defaultValue={this.state.dataKMS.id}
                                                disabled={this.state.disableField}
                                            />
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Kategori</p>
                                            </div>
                                            <input
                                                type="text"
                                                name="category"
                                                className="form-control w-full"
                                                defaultValue={this.state.dataKMS.category}
                                                disabled={this.state.disableField}
                                            />
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Judul</p>
                                                <span className="text-darkred">*</span>
                                            </div>
                                            <input
                                                type="text"
                                                name="title"
                                                placeholder="Tulis Judul"
                                                className="form-control w-full"
                                                defaultValue={this.state.dataKMS.title}
                                                disabled={this.state.disableField}
                                            />
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Deskripsi</p>
                                                <span className="text-darkred">*</span>
                                            </div>
                                            <textarea
                                                type="textarea"
                                                name="description"
                                                placeholder="Tulis Deskripsi"
                                                className="form-control w-full resize-none h-60"
                                                defaultValue={this.state.dataKMS.description}
                                                disabled={this.state.disableField}
                                            />
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Tipe</p>
                                                <span className="text-darkred">*</span>
                                            </div>
                                            <Select
                                                name="type"
                                                options={MENU_KMS.typeOptions}
                                                placeholder="Pilih Tipe"
                                                components={{ IndicatorSeparator: () => null }}
                                                className="w-full"
                                                maxMenuHeight={170}
                                                value={this.state.dataKMS.type}
                                                isDisabled={this.state.disableField}
                                            />
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Gambar</p>
                                            </div>
                                            {!this.state.dataKMS.imageFile ?
                                                <div className="flex justify-center items-center outline-none border-2 border-gray-300 border-dashed p-5 focus:outline-none">
                                                    <div className="flex flex-col items-center w-full relative space-y-2 text-center text-gray-600">
                                                        <IconKMSUpload />
                                                        <p className="font-bold text-xl">Tarik dan letakkan gambar disini</p>
                                                        <p className="">Jenis file : JPG</p>
                                                        <p className="font-semibold">Atau</p>
                                                        <button className={`${this.state.disableField ? "bg-darkgrey" : "bg-olddarkblue"} text-white px-2 py-1 rounded-lg font-medium`}>Cari File</button>
                                                        <input type="file" className="w-full h-full absolute top-0 left-0 opacity-0" accept="image/png, image/jpg, image/jpeg" disabled={this.state.disableEditPage} />
                                                    </div>
                                                </div>
                                                :
                                                <div className={`${this.state.disableField ? "bg-darkgrey" : "bg-gray-100"} flex justify-between p-2 rounded-lg shadow-box-button text-gray-600`}>
                                                    <div className="flex items-center">
                                                        <div className="mr-2">
                                                            <IconKMSImageIcon />
                                                        </div>
                                                        <div className="w-52">
                                                            {(typeof this.state.dataKMS.imageFile) !== "string" ?
                                                                <>
                                                                    <p className="text-lg truncate" title={this.state.dataKMS.imageFile.name}>{this.state.dataKMS.imageFile.name}</p>
                                                                    <p className="text-sm">{Math.round(this.state.dataKMS.imageFile.size / 1024 / 1024 * 100) / 100} MB</p>
                                                                </>
                                                                :
                                                                <>
                                                                    <p className="text-lg truncate" title={this.getFilenameFromUrl(this.state.dataKMS.imageFile)}>{this.getFilenameFromUrl(this.state.dataKMS.imageFile)}</p>
                                                                </>
                                                            }
                                                            <p id="btnviewpicture" className="cursor-pointer text-blue-500" onClick={() => this.setState({ showPopupImage: true })}>Lihat Icon</p>
                                                        </div>
                                                    </div>
                                                    <div className="flex justify-end mt-1 mr-3">
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    {/* Left */}
                                    <div className="space-y-4 flex-initial w-3/12">
                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Link URL</p>
                                            </div>
                                            <input
                                                type="text"
                                                name="urlLink"
                                                placeholder="Tulis Link Url"
                                                className="form-control w-full"
                                                defaultValue={this.state.dataKMS.urlLink}
                                                disabled={this.state.disableField}
                                            />
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Tag</p>
                                            </div>
                                            <CreatableSelect
                                                name="tags"
                                                placeholder="Tulis Tag"
                                                options={this.state.tagOptionsList}
                                                components={{ IndicatorSeparator: () => null, DropdownIndicator: () => null }}
                                                className="w-full"
                                                maxMenuHeight={170}
                                                isMulti
                                                value={this.state.dataKMS.tags}
                                                isDisabled={this.state.disableField}
                                            />
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Status</p>
                                            </div>
                                            <RadioTab radioInputName="status" dataOption={MENU_KMS.dataStatus} defaultCheck={this.state.dataKMS.status} disabled={this.state.disableField} />
                                        </div>

                                        <div className="space-y-1">
                                            <div className="flex font-bold">
                                                <p className="mr-1">Ulasan Pengguna</p>
                                            </div>
                                            <div className={`${this.state.dataKMS.rating > 50 || this.state.dataKMS.totalRate === 0 ? 'bg-lightlimegreen border border-darklimegreen' : 'bg-red-100 border border-red-200'} w-1/2 rounded-xl text-center px-2 py-1 flex justify-center items-center`}>
                                                <p className={this.state.dataKMS.rating > 50 || this.state.dataKMS.totalRate === 0 ? 'text-limegreen font-medium' : 'text-red-500 font-medium'}>{this.state.dataKMS.rating}%</p>
                                                <p className="text-gray-600 ml-1">({this.state.dataKMS.totalRate} Ulasan)</p>
                                            </div>
                                            {
                                                this.state.dataKMS.ratingRemark.map((rating, idx) =>
                                                    <div key={idx}>
                                                        <p className="text-sm">{rating.remark}</p>
                                                        <div className="flex items-center relative">
                                                            <div className="w-full bg-gray-300 rounded-full h-2.5">
                                                                <div className="bg-lightblue h-2.5 rounded-full" style={{ width: `${this.state.dataKMS.totalRate === 0 ? 0 : (100 * rating.rate) / this.state.dataKMS.totalRate}%` }}></div>
                                                            </div>
                                                            <p className="absolute -right-20 pl-1 text-sm">{rating.rate} Ulasan</p>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>

                                {/* Popup Modal Image */}
                                <div className={this.state.showPopupImage ? "block" : "hidden"}>
                                    <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                                        <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none w-5/12 min-w-min">
                                            <div className="body-attachment w-full flex rounded-lg flex-col p-8 font-bold text-lg space-y-5">
                                                <div>
                                                    {(typeof this.state.dataKMS.imageFile) !== "string" ?
                                                        <div className="text-2xl">{this.state.dataKMS.imageFile ? this.state.dataKMS.imageFile.name : ""}</div>
                                                        :
                                                        <div className="text-2xl">{this.state.dataKMS.imageFile && this.getFilenameFromUrl(this.state.dataKMS.imageFile)}</div>
                                                    }
                                                </div>
                                                <div className="flex justify-center items-center">
                                                    {(typeof this.state.dataKMS.imageFile) !== "string" ?
                                                        <img src={this.state.dataKMS.imageFile && URL.createObjectURL(this.state.dataKMS.imageFile)} alt={this.state.dataKMS.imageFile ? this.state.dataKMS.imageFile.name : ""} className="h-96" />
                                                        :
                                                        <img src={this.state.dataKMS.imageFile && this.state.dataKMS.imageFile} alt={"File"} className="h-96" />
                                                    }
                                                </div>
                                                <div className="flex justify-center items-center">
                                                    <button className="bg-olddarkblue text-white py-2 px-6 rounded-lg font-medium" onClick={() => this.setState({ showPopupImage: false })}>Tutup</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(KMSListDetail);